/**
 *
 * CheckpointOperatorFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';

import { CHECKPOINT_OPERATOR_REQUESTS_FORM, CHECKPOINT_OPERATOR_REQUESTS_FORM_DIALOG } from './constants';

function CheckpointOperatorFormDialog({ form }) {
  return (
    <AdvancedFormDialog
      name={CHECKPOINT_OPERATOR_REQUESTS_FORM_DIALOG}
      formName={CHECKPOINT_OPERATOR_REQUESTS_FORM}
      advancedForm={form}
      addModeTitle="Новая заявка"
      editModeTitle="Изменение заявки"
      viewModeTitle="Просмотр заявки"
      copyModeTitle="Копирование заявки"
    />
  );
}

CheckpointOperatorFormDialog.propTypes = {
  form: PropTypes.node.isRequired,
};

export default CheckpointOperatorFormDialog;
